const getUserProfile = (state) => state.designPro.user.userProfile;

export default {
  getUserProfile,
};
